export {};
//# sourceMappingURL=expose-metadata.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/metadata/expose-metadata.interface.js
// module id = 797
// module chunks = 3